export const SEO = {
  head: {
    title: 'How Do Recipe Boxes Work? | Gousto Food Boxes',
    meta: [
      {
        name: 'description',
        content:
          "Not sure if Gousto's for you? Discover the reasons why our food boxes are worth it. Making cooking at home easier and tastier than ever.",
      },
    ],
  },
}
